import syslogServerExtension from "./extensions/syslogServer";

class SyslogServerModel {
  static syslogServerState;

  id = 0;
  checked = false;
  name = '';
  server = '';
  port = '';
  protocol = '';
  siteList = [];
  rawData = {};

  constructor(rawData, selectedOrg) {
    this.id = rawData.id;
    this.name = rawData.name;
    this.server = rawData.host;
    this.port = rawData.port;
    this.protocol = rawData.protocol;

    this.siteList = this._setSites(rawData.storeIds, selectedOrg.storeObj);

    this.rawData = rawData;
  }

  _setSites(siteIds, siteObj) {
    const list = [];

    for (const siteId of siteIds) {
      if (siteObj[siteId.toString()]) {
        const site = siteObj[siteId.toString()];
        list.push({
          id: site.id,
          site: site.name
        });
      }
    }

    return list;
  }

  get siteListLength() {
    return this.siteList.length;
  }
}

for (const funcName in syslogServerExtension) {
  SyslogServerModel[funcName] = syslogServerExtension[funcName];
}

export default SyslogServerModel;